import React from 'react';
import { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { Grid, Button, Typography } from '@mui/material';
import UserColumn from './userColumn';
import { useNavigate } from 'react-router-dom';
import './user.css';
import { getAllUserManagement, userPatchApi } from './user.service';
import Swal from 'sweetalert2';
import Loader from '../../../components/loader';
import GenericDataGrid from '../../../components/genericTable';

export default function User() {

  const navigate = useNavigate();
  const [userData, setUserData] = useState([]);
  const [errors, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [totalDataCount, setTotalDataCount] = useState("");
  const [currenntPagemain, setCurrentPagemain] = useState(0);
  const [rowsperpagemain, setrowsperpagemain] = useState(10);
  const [selectedrows, setSelectedrows] = useState([]);
  const selectedIds = selectedrows?.ids instanceof Set ? Array.from(selectedrows.ids) : [];

  const isSelectedRowsNonPending = userData.filter(row => selectedIds.includes(row.id)).every(row => row.approvalStatus !== 'PENDING');;

  useEffect(() => {
    getUserData(currenntPagemain, rowsperpagemain)
  }, []);

  const getUserData = async (page = currenntPagemain, limit = rowsperpagemain) => {
    const res = await getAllUserManagement(page, limit);
    if (res.statusCode === 200) {
      setUserData(res.data.userList);
      setTotalDataCount(res.data.pagination.totalItems);
    } else if (res.statusCode === 400 || res.statusCode === 401 || res.statusCode === 404 || res.statusCode === 500 || res.statusCode === 429) {
      setUserData([]);
      setError(res.message);
    } else {
      setUserData([]);
      setError(res.message);
    }
  };

  const handleApprovalStatus = async (status, ids = selectedrows) => {

    const userId = ids?.ids instanceof Set ? Array.from(ids.ids) : Array.isArray(ids) ? ids : [];

    if (userId.length === 0) return;

    const data = {
      userIds: userId,
      approvalStatus: status,
    };

    const warningHTML = `
    <div style="display: flex; flex-direction: column; align-items: center;">
      <span class="iconify" data-icon="mdi:alert-circle-outline" style="font-size: 50px; color: #C40000;"></span>
      <div style="font-size: 20px; font-weight: bold; color: #C40000; margin-top: 30px;">Warning!</div>
      <div style="margin-top: 20px;">Do you want to continue?</div>
      <div style="margin-top: 10px;">This action cannot be undone.</div>
    </div>
  `;

    const swalOptions = {
      html: warningHTML,
      showCancelButton: true,
      showCloseButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      buttonsStyling: false,
      customClass: {
        popup: 'CancelModal',
        confirmButton: 'swal2-confirm custom-confirm',
        cancelButton: 'swal2-cancel custom-cancel',
        closeButton: 'swal2-close',
      },
      didOpen: () => {
        const cancelBtn = Swal.getCancelButton();
        if (cancelBtn) {
          cancelBtn.addEventListener('mouseenter', () => { });
          cancelBtn.addEventListener('mouseleave', () => { });
        }
        if (!document.querySelector('script[src*="iconify.min.js"]')) {
          const script = document.createElement('script');
          script.src = 'https://code.iconify.design/2/2.2.1/iconify.min.js';
          script.async = true;
          document.body.appendChild(script);
        }
      },
    };

    const result = await Swal.fire(swalOptions);

    if (result.isConfirmed) {
      try {
        setLoading(true);
        const response = await userPatchApi(data);
        setLoading(false);

        if (response?.statusCode === 200) {
          await Swal.fire({
            title: 'Updated Successfully',
            text: response.message,
            icon: 'success',
            confirmButtonText: 'Close',
            customClass: { popup: 'deletedSwal' },
          });
          getUserData();
          window.location.reload();
        } else if (response?.statusCode === 400 || response?.statusCode === 404 || response?.statusCode === 500) {
          await Swal.fire({
            title: 'Error',
            text: response.message,
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass: { popup: 'deletedSwal' },
          });
        }
        else {
          await Swal.fire({
            title: 'Error',
            text: response.message,
            icon: 'error',
            confirmButtonText: 'Ok',
            customClass: { popup: 'deletedSwal' },
          });
        }
      } catch (error) {
        console.error('An error occurred:', error);
        setLoading(false);
        await Swal.fire({
          title: 'Error',
          text: 'Something went wrong. Please try again.',
          icon: 'error',
          confirmButtonText: 'Ok',
          customClass: { popup: 'deletedSwal' },
        });
      }
    }
  };

  let salesData = {
    'limit': rowsperpagemain,
    'page': currenntPagemain,
    'navigate': navigate,
    'handleApprovalStatus': handleApprovalStatus
  }

  const userColumnData = UserColumn(salesData);

  return (
    <>
      <Grid container mb={2} alignItems={'center'} rowGap={3}>
        <Grid size={{ xs: 12, sm: 4, md: 9, lg: 9, xl: 10 }}>
          <Typography sx={{ fontSize: '28px', fontWeight: 600 }}>User Onboarding</Typography>
        </Grid>

        <Grid size={{ xs: 8, sm: 4, md: 1.5, lg: 1.5, xl: 1 }} textAlign="end">
          <Button variant="contained" className={`rejectBtn ${(selectedrows.length === 0 || isSelectedRowsNonPending) ? 'customDisabled' : ''}`} disabled={selectedrows.length === 0 || isSelectedRowsNonPending} onClick={() => handleApprovalStatus('REJECTED', selectedrows)} >
            Reject
          </Button>
        </Grid>

        <Grid size={{ xs: 5, sm: 3, md: 1.5, lg: 1.5, xl: 1 }} textAlign="end">
          <Button variant="contained" className={`createBtn ${(selectedrows.length === 0 || isSelectedRowsNonPending) ? 'customDisabled' : ''}`} disabled={selectedrows.length === 0 || isSelectedRowsNonPending} onClick={() => handleApprovalStatus('APPROVED', selectedrows)}>
            Approve
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ width: '100%', padding: '0 0px' }}>
        <GenericDataGrid rows={userData} columns={userColumnData} rowCount={totalDataCount} page={currenntPagemain} pageSize={rowsperpagemain} loading={loading} errors={errors} checkbox='true'
          onPaginationChange={(page, pageSize) => {
            setCurrentPagemain(page);
            setrowsperpagemain(pageSize);
            getUserData(page, pageSize);
          }}
          onSelectionChange={(newSelection) => setSelectedrows(newSelection)} isRowSelectable={(row) => row.approvalStatus !== 'APPROVED' && row.approvalStatus !== 'REJECTED'
          } />

      </Box>

      {loading && <Loader />}
    </>
  );
}